<template>
  <div class="bb-string-cell"
       :ref="row.id"
       :class="{'bb-string-cell_space-between': column.spaceBetween}"
       @click.stop="clickCell"
  >
    <span
      v-if="isHavePrompt && promptValue"
      class="bb-string-cell__prompt"
      @mouseenter="onMouseenter"
      @mouseleave="closePopup"
      v-html="InfoIcon()"
    />
    <div v-if="column.editable && row.openEdit">
      <input class="bb-input bb-input_border
                  bb-string-cell-input
                  bb-string-cell-input_bank"
             :class="{'bb-input_error' : error}"
             @focus="focusInput"
             v-model="value"
             @input="checkedInput(row, column, index)"
      />
      <span class="bb-string-cell__error" v-if="error">{{error}}</span>
    </div>
    <span class="bb-string-cell-text"
          ref="projectName"
          @mouseenter="setPositionPopup($event, row._id, 'projectName')"
          @mouseleave="showName = false"
          v-else
          v-html="value"
          :class="[
            {
              'bb-string-cell-text_capitalize': column.capitalize,
              'bb-string-cell-text_with-hover': column.route || column.hover,
            },
            getCustomClass,
            hoverClass
          ]"
    >
      {{value}}
    </span>
    <transition name="fade" mode="out-in">
      <div class="bb-string-cell-popup"
           v-if="checkProjectName"
           :style="openPopup"
      >
        Project name: {{displayNameProject.text}}
      </div>
    </transition>
    <div class="bb-string-cell-marks">
      <div class="bb-string-cell-mark"
           ref="popupInfo"
           @mouseenter="setPositionPopup($event, row._id, 'popupInfo', mark)"
           @mouseleave="showPopup = false"
           v-if="markDisplay.length"
           v-for="mark in markDisplay"
           :key="mark"
      >
        {{mark}}
        <transition name="fade" mode="out-in">
          <div v-if="showPopup"
               :style="openPopup"
               class="bb-string-cell-popup"
          >
            <div class="bb-string-cell-popup__item"
                 v-if="checkProject"
                 v-for="userKpiHelp in getUsersHelpKpi"
                 :key="userKpiHelp._id"
            >
              <span class="bb-string-cell-popup__item_weight">{{userKpiHelp.percent}}%</span>
              <span>{{userKpiHelp.user.username}}</span>
            </div>
            <div v-if="checkTransfer">
              <span class="bb-string-cell-popup__text">{{transferUser}}</span>
            </div>
          </div>
        </transition>
      </div>
      <div class="bb-string-cell-mark"
           v-if="enumDisplay"
      >
        {{enumDisplay}}
      </div>
    </div>
    <div class="bb-string-cell-icons"
         ref="commentText"
         v-if="displayComment.display"
    >
      <i class="icon-info bb-string-cell__icon"
         @mouseenter="setPositionPopup($event, row._id, 'commentText')"
         @mouseleave="showText = false"
      />
      <transition name="fade" mode="out-in">
        <div v-if="showText === row._id"
             :style="openPopup"
             class="bb-string-cell-popup"
        >
          <span class="bb-string-cell-popup__text">
            {{displayComment.text}}
          </span>
        </div>
      </transition>
    </div>
    <PopupInfo
      v-if="isShowPromptPopup && promptValue"
      :styleCustom="popupPosition"
      to="#app"
      :text="promptValue"
      @close="closePopup"
    />
  </div>
</template>

<script>
import _, {get, set} from 'lodash'
import convertNumber from '@/mixin/convertNumber'
import {InfoIcon} from '@/constants/icon'
import PopupInfo from "../../PopupInfo/PopupInfo.vue";

export default {
  name: 'BBStringCell',
  components: {PopupInfo},
  props: ['row', 'column', 'index', 'hover'],
  mixins: [convertNumber],
  data () {
    return {
      showPopup: false,
      showName: false,
      showText: false,
      hoverClass: '',
      project: {
        kpiHelpUsers: []
      },
      openPopup: {
        left: 0,
        top: 0
      },
      isShowPromptPopup: false,
      popupPosition: {},
      InfoIcon
    }
  },
  computed: {
    isHavePrompt() {
      const { isHavePrompt = false } = this.column;
      return isHavePrompt;
    },
    promptValue() {
      if (!this.isHavePrompt) return '';

      const { propPrompt } = this.column;
      return this.row[propPrompt];
    },
    isHoveredRow() {
      return this.hover === this.row.id
    },
    value: {
      get: function () {
        const isNumber = this.column.type === 'number'
        const fromProp = get(this.row, this.column.prop, '')
        const prefix = get(this.column, 'prefix', '')
        const postfix = get(this.column, 'postfix', '')
        let value = get(this.row, this.column.display, fromProp)
        value = (isNumber && (!this.column.editable || !this.row.openEdit)) ? this.convertNumber(value) : value
        return prefix + value + postfix
      },
      set: function (data) {
        return set(this.row, this.column.prop, data)
      }
    },
    transferUser () {
      return get(this.row, 'transferUser.username', '')
    },
    getCustomClass () {
      const customFunction = get(this.column, 'customClass', () => {})
      const prop = get(this.column, 'prop', '')
      const value = get(this.row, prop, 0)
      return customFunction(value)
    },
    checkProjectName () {
      return this.showName === this.row._id && this.displayNameProject.display
    },
    checkProject () {
      const projectId = get(this.row, ['project', '_id'], '')
      const kpiHelpUsers = get(this.row, 'project.kpiHelpUsers', [])
      return projectId && kpiHelpUsers.length && this.showPopup === this.row._id
    },
    getUsersHelpKpi () {
      return get(this.row, 'project.kpiHelpUsers', [])
    },
    checkTransfer () {
      return this.markDisplay.includes('Transfer') && this.showPopup === this.row._id
    },
    error: {
      get: function () {
        return get(this.row, this.column.error, '')
      },
      set: function (data) {
        return set(this.row, this.column.error, data)
      }
    },
    markDisplay: {
      get: function () {
        const result = []
        const prop = get(this.column, 'billet.display', [])
        const text = get(this.column, 'billet.text', [])
        prop.forEach((item, index) => {
          const value = get(this.row, item, '')
          if (value) {
            result.push(text[index])
          }
        })
        return result
      }
    },
    displayComment () {
      const prop = get(this.column, 'info.display', '')
      const propText = get(this.column, 'info.text', '')
      const valueDisplay = get(this.row, prop, '')
      const valueText = get(this.row, propText, '')
      return {
        display: valueDisplay,
        text: valueText
      }
    },
    displayNameProject () {
      const prop = get(this.column, 'nameProject.display', '')
      const propText = get(this.column, 'nameProject.text', '')
      const valueDisplay = get(this.row, prop, '')
      const valueText = get(this.row, propText, '')
      return {
        display: valueDisplay,
        text: valueText
      }
    },
    enumDisplay: {
      get: function () {
        const prop = get(this.column, 'enum.prop', '')
        const enumGetter = get(this.column, 'enum.getter', () => {})
        const value = get(this.row, prop, '')
        return enumGetter(value)
      }
    }
  },
  methods: {
    clickCell () {
      const isRoute = get(this.column, ['route', 'name'], '')
      const action = get(this.column, 'action', '')
      if (isRoute) this.goToRoute(isRoute)
      if (action && typeof action === 'function') action(this.row, this.column)
    },
    goToRoute (routeName) {
      const router = {
        name: routeName
      }
      const paramName = get(this.column, ['route', 'paramName'], '')
      const paramProp = get(this.column, ['route', 'paramValue'], '')
      const paramValue = get(this.row, paramProp, '')
      if (paramName && paramValue) {
        router.params = {
          [paramName]: paramValue
        }
      }
      this.$router.push(router)
    },
    setPositionPopup (e, rowId, ref, mark) {
      if (ref === 'projectName') {
        this.showName = rowId
      }
      if (ref === 'popupInfo' && mark !== 'Dues paid') {
        this.showPopup = rowId
      }
      if (ref === 'commentText') {
        this.showText = rowId
      }
      const popups = get(this.$refs, ref, '')
      const popupWidth = get(popups[0], 'offsetWidth', 0)
      const diffLeft = popupWidth / 2
      const box = e.target.getBoundingClientRect()
      this.openPopup = {
        left: (box.left - diffLeft + 5) + 'px',
        top: box.top + 30 + 'px'
      }
    },
    checkedInput (row, column, index) {
      if (column.notMore) {
        this.checkedNoteMore(row, column, index)
      }
    },
    focusInput () {
      if (this.error) this.error = ''
    },
    checkedNoteMore (row, column, index) {
      const number = this.validateNum(this.value)
      const propertyValue = get(column, 'notMore', '')
      const amountValue = _.get(row, propertyValue, 0)
      if (number > amountValue) {
        this.value = amountValue
      }
    },
    validateNum (number) {
      if (typeof number === 'string') {
        number = number.replace(/[^.\d;]/g, '')
      }
      if (isNaN(number)) {
        return 0
      } else {
        return +number
      }
    },
    onMouseenter(e) {
      const { top, left } = e.target.getBoundingClientRect();
      this.popupPosition = {
        top: `${top + 20}px`,
        left: `${left}px`,
        maxWidth: '300px',
      };

      this.isShowPromptPopup = true;
    },
    closePopup() {
      this.isShowPromptPopup = false;
      this.popupPosition = {};
    },
  },
  watch: {
    hover () {
      if (this.hover === this.row._id) {
        const hoverClass = get(this.column, 'hoverClass', '')
        this.hoverClass = hoverClass
      } else {
        this.hoverClass = ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../sass/variables";
@import "../../../../sass/mixins";

.bb-string-cell {
  @include global-font;
  display: flex;
  align-items: center;
  position: relative;
  height: 100%;

  &__prompt {
    flex: 0 0 15px;
    margin-right: 4px;
    transform: translateY(1px);
  }

  &__copy-icon {
    flex: 0 0 22px;
    height: 22px;
    border-radius: 50%;
    cursor: pointer;
    overflow: hidden;
    transform: translateY(1px);
    margin-right: 6px;

    img {
      max-width: 100%;
    }
  }

  &__copied-message {
    padding: 3px 5px;
    border-radius: 4px;
    background-color: rgba($color-accent, 0.2);
    color: $color-accent;
    margin-right: 6px;
  }

  &__error {
    position: absolute;
    left: -15px;
    top: 32px;
    color: $color-red-orange;
    font-size: 11px;
    line-height: 13px;
    z-index: 2;
  }

  &-popup {
    display: grid;
    z-index: 2;
    grid-row-gap: 10px;
    max-width: 458px;
    position: fixed;
    background: $color-white;
    box-shadow: 0 0 12px rgba($color-black, 0.12);
    border-radius: 5px;
    color: black;
    padding: 12px;
    pointer-events: none;

    &__item {
      display: grid;
      grid-template-columns: 25px auto;
      grid-gap: 6px;
      font-size: 12px;
      line-height: 14px;
      font-weight: 500;
      text-transform: capitalize;

      &_weight {
        font-weight: bold;
      }
    }

    &__text {
      font-size: 12px;
      line-height: 14px;
      font-weight: 500;
      text-transform: capitalize;
    }
  }

  &:last-child {
    margin-bottom: 0;
  }

  &__button {
    height: 30px;
    width: 60px;
    min-width: 60px;
    margin-left: 10px;
  }

  &-text {
    text-overflow: ellipsis;
    align-items: center;
    position: relative;
    word-break: break-all;
    z-index: 1;
    height: 100%;

    &_capitalize {
      text-transform: capitalize;
    }

    &_with-hover {
      cursor: pointer;
      transition: 0.3s;

      &:hover {
        color: $color-accent;
      }
    }
  }

  &__icon {
    cursor: pointer;
    color: $color-silver-chalice;
  }

  &-icons {
    margin: auto 0 auto 5px;
  }

  &-marks {
    flex-wrap: wrap;
  }

  &-mark {
    position: relative;
    white-space: nowrap;
    margin: auto 0 3px 5px;
    padding: 3px 4px;
    background: rgba($color-accent, 0.2);
    border-radius: 2px;
    font-weight: 500;
    font-size: 11px;
    line-height: 13px;
    text-align: center;
    color: $color-accent;
  }

  &-input {
    width: 100%;
    margin-left: -15px;

    &_bank {
      max-width: 116px;
    }
  }
}

</style>
<style lang="scss">
@import "../../../../sass/variables";
@import "../../../../sass/mixins";

.bb-string-cell {
  b {
    font-weight: bold;
    font-size: 14px;
    line-height: 17px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Main/BBTable/StringCell/StringCell.vue